import { render, staticRenderFns } from "./funds.vue?vue&type=template&id=6e206251&scoped=true"
import script from "./funds.vue?vue&type=script&lang=js"
export * from "./funds.vue?vue&type=script&lang=js"
import style0 from "./funds.vue?vue&type=style&index=0&id=6e206251&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e206251",
  null
  
)

export default component.exports